import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { ReactNode } from 'react';

type TransitionIconButtonProps = {
	onClick?: (event: React.MouseEvent<HTMLElement>) => void;
	title: string;
	color?: 'primary' | 'secondary' | 'info' | 'inherit' | 'default' | 'error' | 'success' | 'warning';
	children: ReactNode;
	disabled?: boolean;
};

export function TransitionIconButton({ onClick, title, color = 'primary', children, disabled = false }: TransitionIconButtonProps) {
	return (
		<Tooltip title={title}><span>
		<IconButton
			onClick={(event) => { event.stopPropagation(); onClick?.(event); }}
			size="small"
			color={color}
			aria-label={title}
			disabled={disabled}
			sx={{
				width: 26, height: 26, padding: '4px', borderRadius: 1,
				'& .MuiSvgIcon-root': { fontSize: 16 },
				'&:hover': { backgroundColor: 'action.hover' },
			}}
		>
			{children}
		</IconButton>
		</span></Tooltip>
	);
}
